import React from 'react';
import { TTypographyProps } from './Typography.types';
import { STypography } from './Typography.styles';

const Typography = ({ fontSize, fontWeight, ...props }: TTypographyProps) => {
  return <STypography $fontSize={fontSize} $fontWeight={fontWeight} {...props} />;
};

export default Typography;
